import { InvoiceListRowsSkeleton } from "../loading/SkeletonBlocks.jsx";
import { formatMoneyCents } from "../../lib/money.js";
import { formatBillingInstant } from "../../lib/stripeInstant.js";

function formatPayoutStatus(status) {
  const key = String(status ?? "").toLowerCase();
  const map = {
    paid: "Paid",
    pending: "Pending",
    in_transit: "In transit",
    canceled: "Canceled",
    failed: "Failed",
  };
  return map[key] ?? (key ? key.charAt(0).toUpperCase() + key.slice(1) : "Unknown");
}

function statusVariant(status) {
  const key = String(status ?? "").toLowerCase();
  if (key === "paid") return "border-hc-success/35 bg-hc-success-muted text-hc-success";
  if (key === "failed" || key === "canceled") {
    return "border-hc-error/35 bg-hc-error/10 text-hc-error";
  }
  return "border-hc-warning/35 bg-hc-warning-muted text-hc-warning";
}

export default function PayoutHistoryList({ payouts, isLoading, className = "" }) {
  return (
    <section
      className={`overflow-hidden rounded-2xl border border-hc-surface-border bg-hc-surface ${className}`}
    >
      <div className="border-b border-hc-surface-border px-5 py-3.5">
        <h2 className="text-sm font-semibold tracking-[-0.15px] text-hc-text">Payout history</h2>
      </div>

      {isLoading ? (
        <InvoiceListRowsSkeleton rows={3} />
      ) : payouts.length === 0 ? (
        <p className="px-5 py-6 text-xs text-hc-text-dim">No payouts yet.</p>
      ) : (
        <ul className="divide-y divide-hc-surface-border/80">
          {payouts.map((payout) => (
            <li
              key={payout.id}
              className="flex flex-wrap items-center justify-between gap-3 px-5 py-4"
            >
              <div className="flex min-w-0 items-center gap-3">
                <span
                  className={`shrink-0 rounded-full border px-2 py-0.5 text-xs font-medium ${statusVariant(payout.status)}`}
                >
                  {formatPayoutStatus(payout.status)}
                </span>
                <div>
                  <p className="text-sm tracking-[-0.15px] text-hc-text">
                    {formatBillingInstant(payout.arrivalDate) || "Payout"}
                  </p>
                  <p className="text-xs text-hc-text-dim">{payout.id}</p>
                </div>
              </div>
              <span className="text-sm font-semibold tracking-[-0.15px] text-hc-text">
                {formatMoneyCents(payout.amountCents, payout.currency)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
